import { EvochaClient, type TokenPair } from "@evocha/api-client";

function resolveBaseUrl(): string {
  const env = import.meta.env as Record<string, string | undefined>;
  const configured = (env.VITE_API_URL ?? "").trim();
  if (configured) {
    return configured
      .replace(/\/+$/, "")
      .replace(/\/superdealer\/v1$/, "")
      .replace(/\/v1$/, "");
  }
  return "http://localhost:8000";
}

export const API_BASE_URL = resolveBaseUrl();

export const DEALER_STORAGE_KEY = "evocha.dealer.session";

function readStored(): Record<string, unknown> | null {
  try {
    const raw = localStorage.getItem(DEALER_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export const dealerApi = new EvochaClient({
  baseUrl: API_BASE_URL,
  refreshPath: "/superdealer/v1/auth/refresh",
  timeoutMs: 25_000,
  getToken: () => {
    const stored = readStored();
    return typeof stored?.access_token === "string" ? stored.access_token : null;
  },
  getRefreshToken: () => {
    const stored = readStored();
    return typeof stored?.refresh_token === "string" ? stored.refresh_token : null;
  },
  onTokensRefreshed: (tokens: TokenPair) => {
    try {
      const stored = readStored() ?? {};
      localStorage.setItem(DEALER_STORAGE_KEY, JSON.stringify({ ...stored, ...tokens }));
    } catch {
      /* ignore */
    }
  },
  onUnauthorized: () => {
    try {
      localStorage.removeItem(DEALER_STORAGE_KEY);
    } catch {
      /* ignore */
    }
  },
  headers: () => ({ "X-Client": "evocha-dealer/1.0.0" }),
});
